module.exports = __webpack_public_path__ + "nunito-sans-latin-700italic.ffc1f5c22dc4b08f710c027976972de1.woff";